import React from 'react';
import MainLayout from '../../layouts/MainLayout';
import mapsMobile from "../../assets/img/contact/map-mobile.svg";
import mapsImg from "../../assets/img/contact/map.svg";

function ContactUs() {
  return (
    <MainLayout>
      <section>
        <div className="app-forager-international-about with-curved-bottom bg-no-repeat bg-cover px-0 pt-5">
          <div className="h-48 md:h-44 lg:mt-14 grid place-items-center">
            <h1 className="text-white text-4xl lg:text-6xl">contact</h1>
          </div>
        </div>
        <div className="grid grid-cols-5 grid-rows-auto gap-x-6 container mx-auto mt-9 md:mt-14">
          <div className="row-span-2 my-auto col-span-5 lg:col-span-3 order-2 lg:order-3 md:pl-8 px-4 lg:px-0">
            <h2 className="text-navy-blue text-4xl text-center md:text-start with-line-above before:w-1/2 md:before:w-1/5 before:border-navy-blue line-above-center md:line-above-start">
              get in touch
            </h2>
            <p className="my-6">
              {" "}
              We are always looking for ways to make new connections and engage
              with our community. If you are interested in learning more about
              Forager International, the businesses that we manage, or are
              interested in becoming our newest partner, reach out and one of our
              team will be happy to answer your questions.
            </p>
            <p>
              <span className="block md:inline font-bold text-navy-blue">phone / whatsApp: </span>
              +1 250 569 4401
            </p>
            <p className="mt-2">
            <span className="font-bold text-navy-blue">
              general enquiries:{" "}
            </span>
              info@foragerinternational.com
            </p>
            <p className="mt-2">
            <span className="font-bold text-navy-blue">
              investor relations:{" "}
            </span>
              invest@foragerinternational.com
            </p>
            <p className="mt-2">
            <span className="font-bold text-navy-blue">
              partnership enquiries:{" "}
            </span>
              partners@foragerinternational.com
            </p>
            <p className="hidden lg:block mt-2">
            <span className="font-bold text-navy-blue">
            global hq:{" "}
            </span>
              Cork, Ireland
            </p>
          </div>
          <div className="col-span-5 lg:col-span-2 lg:row-span-2 order-3 lg:order-2 mt-14 mb-11 lg:my-0 px-4 lg:px-0">
            <img src={mapsMobile} alt="forager gives back" className="lg:hidden w-full mx-auto" />
            <img src={mapsImg} alt="forager gives back" className="hidden lg:block w-full" />
          </div>
          <div className="lg:hidden col-span-5 order-4 flex flex-col lg:flex-row items-center gap-8">
            <h3 className="text-2xl font-semibold text-navy-blue">
              global hq
              <span className="text-center mt-4 text-base font-normal block text-dark-denim">
              Cork, Ireland
            </span>
            </h3>
          </div>
          <div className="col-span-5 order-5 px-4 lg:px-0">
            <h4 className="text-navy-blue font-semibold text-xl mt-10 mb-4">
              get in touch
            </h4>
            <p>
              Fields marked with an * are required
            </p>
            <form
              action=""
              method="POST"
              className="mt-10 lg:mt-14 mb-24 grid grid-cols-2 gap-5 lg:gap-7 "
              autoComplete="off"
            >
              <label className="col-span-2 md:col-span-1">
                name*
                <input
                  type="text"
                  name="name"
                  className="h-14 rounded-xl border w-full mt-2 p-4"
                  required
                />
              </label>
              <label className="col-span-2 md:col-span-1">
                email*
                <input
                  type="email"
                  name="email"
                  className="h-14 rounded-xl border w-full mt-2 p-4"
                  required
                />
              </label>
              <label className="col-span-2 ">
                subject*
                <input
                  type="text"
                  name="subject"
                  className="h-14 rounded-xl border w-full mt-2 p-4"
                  required
                />
              </label>
              <label className="col-span-2">
                message*
                <textarea
                  name="message"
                  className="h-32 rounded-xl border w-full mt-2 p-4"
                  required
                />
              </label>
              <input
                type="submit"
                value="submit"
                className="col-span-2 mt-12 lg:mt-5 bg-navy-blue hover:bg-dark-denim w-full md:w-48 h-12 rounded-3xl text-white mx-auto shadow-lg"
              />
            </form>
          </div>
        </div>
      </section>
    </MainLayout>
  );
}

export default ContactUs;
